import { useTranslation } from "react-i18next";
import { EmptyState } from "@tellescope/design-system";
import { Sparkles } from "lucide-react";

export const AISummaryEmptyPreview = () => {
  const { t } = useTranslation("contacts");

  return (
    <EmptyState size="compact" className="w-full">
      <EmptyState.Media>
        <Sparkles className="h-5 w-5 text-muted-foreground" />
      </EmptyState.Media>
      <EmptyState.Subtitle>{t("No AI summary yet")}</EmptyState.Subtitle>
    </EmptyState>
  );
};
